import type { ActivityDetails } from '../../../typings'
import type { State } from '../../../state'
import { initialState } from '../../../state'

export function updateLeadActivityProducer(
  state: State,
  payload?: ActivityDetails,
): State {
  const activities = state.activities.map((activity) =>
    payload && activity.id === payload.id ? payload : activity,
  )

  return {
    ...initialState,
    filters: state.filters,
    history: state.history,
    activities,
  }
}
